<template>
    <div v-if="$store.state.isModalOpenFour" class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-lg modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                          <h4 class="mb-0">Employee Offboarding Clearance and Approval Status</h4>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

                <div class="pb-2">
                  <div class="row mx-2">
                    <div class="table-responsive">
                      <table class="table">
                        <thead>
                        <tr>
                          <th class="text-left">Approver Name</th>
                          <th class="text-center">Remarks</th>
                          <th class="text-center">Update At</th>
                          <th class="text-center">Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, i) in clearanceData.employee_offboarding_logs" :key="i">
                          <td class="text-center">{{ item.employee_name }}</td>
                          <td class="text-center">{{ item.remarks }}</td>
                          <td class="text-center">{{ item.formatted_updated_at }}</td>
                          <td class="text-center text-capitalize">{{ item.status }}</td>
                        </tr>
                        </tbody>
                      </table>
                      <p v-if="clearanceData.employee_offboarding_logs.length < 0" class="text-center mt-5">No data</p>
                    </div>
                    </div>
                 </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from "vue";
import { useStore } from "vuex";

const props = defineProps({
  clearanceData:{
      type:Object,
      default:{}
    }
});

const $store = useStore();
const modalRef = ref(null);
const onClickClose = () => {
    $store.state.isModalOpenFour = false;
}
</script>
